(function () {
  'use strict';

  /* Default is always DAY. EVENING only after the shopper picks it; the choice is remembered. */
  var CHOICE_KEY = 'ticho-theme-choice';

  function apply(theme, userInitiated) {
    var root = document.documentElement;
    root.setAttribute('data-ticho-theme', theme);

    if (userInitiated) {
      try {
        localStorage.setItem(CHOICE_KEY, theme);
      } catch (e) {
        /* Storage unavailable — current-page theme still applies. */
      }
    }

    var isEvening = theme === 'evening';
    var toggles = document.querySelectorAll('[data-ticho-theme-toggle]');
    for (var i = 0; i < toggles.length; i++) {
      var toggle = toggles[i];
      toggle.setAttribute('aria-pressed', isEvening ? 'true' : 'false');
      var label = toggle.getAttribute(isEvening ? 'data-label-day' : 'data-label-evening');
      if (label) toggle.setAttribute('aria-label', label);
    }

    document.dispatchEvent(new CustomEvent('ticho:themechange', {
      detail: { theme: theme, userInitiated: !!userInitiated }
    }));
  }

  function current() {
    return document.documentElement.getAttribute('data-ticho-theme') === 'evening' ? 'evening' : 'day';
  }

  function storedChoice() {
    try {
      return localStorage.getItem(CHOICE_KEY) === 'evening' ? 'evening' : 'day';
    } catch (e) {
      return current();
    }
  }

  document.addEventListener('click', function (event) {
    var choice = event.target.closest && event.target.closest('[data-ticho-signature-choice]');
    if (choice) {
      apply(choice.getAttribute('data-theme') === 'evening' ? 'evening' : 'day', true);
      return;
    }

    var toggle = event.target.closest && event.target.closest('[data-ticho-theme-toggle]');
    if (!toggle) return;
    apply(current() === 'evening' ? 'day' : 'evening', true);
  });

  function init() {
    apply(current(), false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  /* Keep other open tabs in sync with the shopper's choice. */
  window.addEventListener('storage', function (event) {
    if (event.key !== CHOICE_KEY) return;
    var theme = storedChoice();
    if (theme !== current()) apply(theme, false);
  });
})();
